// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ewhl","controls":"styles_controls__2wvRU","charLimit":"styles_charLimit__2t4W9","input":"styles_input__34Qzd","send":"styles_send__1fhdp"};